
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audits",
      function () {
        return require("private-next-pages/audits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/audits"])
      });
    }
  